export class PathwayConstants {
  public static readonly STEP_TYPE_INTRO = 'INTRO' as const;
  public static readonly PRACTICE_TYPE_PATHWAY = 'PATHWAY' as const;
  
  // Get Next Step API Statuses
  public static readonly API_STATUS_NEXT_AVAILABLE = 'NEXT_AVAILABLE' as const;
  public static readonly API_STATUS_COMPLETED = 'COMPLETED' as const;
  public static readonly API_STATUS_BLOCKED = 'BLOCKED' as const;
  public static readonly API_STATUS_REDIRECTED = 'REDIRECTED' as const;
  
  // Run Step API Statuses
  public static readonly API_STATUS_STARTED = 'STARTED' as const;
  public static readonly API_STATUS_ERROR = 'ERROR' as const;
  
  // Complete Step API Statuses
  public static readonly API_STATUS_PREAMBLE_COMPLETED = 'PREAMBLE_COMPLETED' as const;
  public static readonly API_STATUS_REQUIREMENTS_NOT_MET = 'REQUIREMENTS_NOT_MET' as const;
  public static readonly REASON_PATHWAY_COMPLETED = 'PATHWAY_COMPLETED' as const;
  public static readonly REASON_STEP_ALREADY_COMPLETED = 'ALREADY_COMPLETED' as const;
  
  // Run Step API Blocked Reasons
  public static readonly REASON_ANOTHER_STEP_ACTIVE = 'ANOTHER_STEP_ACTIVE' as const;
  public static readonly REASON_ENROLLMENT_LOCKED = 'ENROLLMENT_LOCKED' as const;

  public static readonly CALL_FLOW_GUIDE = 'guide' as const;
  public static readonly CALL_FLOW_PDF = 'pdf' as const;
  public static readonly CALL_FLOW_VIDEO = 'video' as const;
  public static readonly CALL_FLOW_ERROR = 'error' as const;
  public static readonly CALL_FLOW_QUIZ_RESULT = 'quiz-result' as const;
  public static readonly POLLING_INTERVAL_MS = 200;
}